import { Stack } from '@lingoda/ui';
import { ActivityChallengeParticipantStatusEnum } from '@lingoda/monolith-graphql';
import type { BasicActivityChallengeListDataQuery } from '@lingoda/monolith-graphql';
import {
    ActiveChallengeWidgetJoined,
    ActiveChallengeWidgetUnjoined,
} from './ActiveChallengeWidget';

interface Props {
    activityChallenges: BasicActivityChallengeListDataQuery['activityChallenges'];
}

export const ActiveChallengeWidgets = ({ activityChallenges }: Props) => {
    return (
        <Stack spacing={2}>
            {activityChallenges.map((challenge) =>
                challenge.currentParticipant?.status ===
                ActivityChallengeParticipantStatusEnum.Joined ? (
                    <ActiveChallengeWidgetJoined
                        key={challenge.name}
                        challengeName={challenge.name}
                        title={challenge.publicName}
                        startDate={challenge.startDate}
                        endDate={challenge.endDate}
                        prizes={challenge.prizes}
                        completedActivities={challenge.currentParticipant?.completedActivities ?? 0}
                        challengeIconUrl={challenge.challengeIcon?.urls.original}
                    />
                ) : (
                    <ActiveChallengeWidgetUnjoined
                        key={challenge.name}
                        challengeName={challenge.name}
                        startDate={challenge.startDate}
                        endDate={challenge.endDate}
                        publicName={challenge.publicName}
                        participants={challenge.participants}
                        userStatus={challenge.currentParticipant?.status}
                        desktopImageUrl={challenge.desktopBackgroundImage?.urls.original}
                        mobileImageUrl={challenge.mobileBackgroundImage?.urls.original}
                        desktopBackgroundTheme={challenge.desktopBackgroundTheme}
                        mobileBackgroundTheme={challenge.mobileBackgroundTheme}
                    />
                ),
            )}
        </Stack>
    );
};
